/* eslint-disable import/prefer-default-export */
export const auditMissionCreateFormSelector = (state) =>
  state.forms.audit_mission.create
